var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rd-tag-group',{attrs:{"list":(_vm.row.tagList && _vm.row.tagList.map(item => item.tagName)) || [],"max":2,"canEdit":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }